import React from "react";

function HeroAbout() {
  return (
    <>
      <div className="relative overflow-hidden text-white">
        <div
          className="absolute inset-0 bg-cover bg-center "
          style={{
            backgroundImage:
              "url('/assets/img/bg/the_story_behind_hero_img.jpg')",
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
          }}
        />
        <div className="relative z-10 container mx-auto px-6 py-28">
          <div className="max-w-3xl">
            <h1 className="text-4xl md:text-6xl font-bold leading-tight mb-6 text-white pt-100">
              The Story Behind
              <span className="bg-gradient-to-r from-indigo-400 to-purple-400 bg-clip-text text-transparent">
                {" "}
                <br />
                Xeer Technology
              </span>
            </h1>
            <div className="space-y-4 text-lg text-slate-200 leading-relaxed">
              <p className="text-white">
                Xeer Technology was built on one belief — great ideas need
                strong execution.
              </p>
              <p className="text-white">
                As a trusted blockchain development company in India, we help
                startups and enterprises turn ideas into scalable digital
                products using Blockchain, AI, Web3, and modern software
                systems.
              </p>
              <p className="text-white">
                From smart contract development to AI automation, crypto
                exchanges, and token creation, our expert team delivers secure
                and scalable solutions built for long-term growth.
              </p>
            </div>
            <div className="flex flex-wrap gap-4 mt-8">
              <div className="px-5 py-3 bg-white/10 border border-white/20 rounded-xl backdrop-blur-md text-sm">
                One team. Built to scale.
              </div>
              <div className="px-5 py-3 bg-indigo-500/20 border border-indigo-400/30 rounded-xl backdrop-blur-md text-sm">
                8+ Years of Experience Delivering Real-World Digital Solutions
                Globally
              </div>
            </div>
            <div className="mt-10 pb-50">
              <a href="/case-studies">
                <button className="px-8 py-4 bg-gradient-to-r from-indigo-500 to-purple-500 rounded-full font-semibold text-lg shadow-lg hover:scale-105 transition">
                  Explore Our Work →
                </button>
              </a>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default HeroAbout;
